import React from "react";
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";
const CustomAccordionItem = props => {
  return (
    <AccordionItem className="custom-accordion-item">
      <AccordionItemHeading>
        <AccordionItemButton className="custom-accordion-class">
          <span>{props.title}</span>
          <div className="ml-auto circle plus" />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel className="custom-accordion-panel">
        <p>{props.body}</p>
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default CustomAccordionItem;
